import { Component, Output, EventEmitter, ViewChild, Input, forwardRef} from '@angular/core';
import { BaseUiFormControl } from '../base-ui-form-control';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  selector: 'ui-dropdown-with-button',
  templateUrl: './ui-dropdown-with-button.component.html',
  styleUrls: ['./ui-dropdown-with-button.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting:  forwardRef(() => UiDropdownWithButtonComponent),
    multi: true
  }]
})
export class UiDropdownWithButtonComponent extends BaseUiFormControl implements ControlValueAccessor {
  @Input() lookup: any[] = [];
  @Input() lookupName? :string= undefined;
  @Input() placeholder?: string = "Select an Option";
  @Input() buttonLabel: string = '...';
  @Input() buttonCssClass: string = '';
  @Output() buttonClick: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild(FormControlDirective) formControlDirective: FormControlDirective;

  constructor(controlContainer: ControlContainer) {
    super(controlContainer);
  }

  onButtonClick() {
    this.buttonClick.emit();
  }
  onChangeClick() {
    this.onChange.emit();
  }
  get value() {
    return this.control.value;
  }
  set value(value) {
    this.onChange(value);
    this.onTouched();
  }
  onChange: any = () => {};
  onTouched: any = () => {};
  registerOnChange(fn) {
    this.onChange = fn;
  }
  writeValue(value) {
    if (value) {
      this.value = value;
    }
    else {
      this.value=null;
    }

  }
  setDisabledState(isDisabled: boolean): void {
    if(isDisabled)
      this.control.disable();
    else
      this.control.enable();
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  validate(_: FormControl) {
    return this.control.valid ? null : { profile: { valid: false } };
  }
  clear() {
    this.writeValue(null);
  }

}
